import { Boxes } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const enrollmentCategoryOptionsMedical: ComboboxFilterOption<string>[] = [
  { label: 'General Medical', value: 'general_medical' },
  { label: 'Off-Thatch Medical', value: 'off_thatch_medical' },
  { label: 'Subsidy', value: 'subsidy' },
  { label: 'Medicare', value: 'medicare' },
  { label: 'Medicare (Part A)', value: 'medicare_part_a' },
  { label: 'Medicare (Part B)', value: 'medicare_part_b' },
  { label: 'Medicare (Part C)', value: 'medicare_part_c' },
  { label: 'Medicare (Part D)', value: 'medicare_part_d' },
  { label: 'Medicare Supplement', value: 'medicare_supplement' },
]

const enrollmentCategoryOptionsDental: ComboboxFilterOption<string>[] = [
  { label: 'Guardian', value: 'guardian_dental' },
  { label: 'Renaissance', value: 'renaissance_dental' },
  { label: 'BlueShield of California', value: 'bsca_dental' },
  { label: 'Off-Thatch Dental', value: 'off_thatch_dental' },
]

const enrollmentCategoryOptionVision: ComboboxFilterOption<string>[] = [
  { label: 'VSP', value: 'vsp' },
  { label: 'BlueShield of California', value: 'bsca_vision' },
  { label: 'Off-Thatch Vision', value: 'off_thatch_vision' },
]

const enrollmentCategoryOptions = [
  ...enrollmentCategoryOptionsMedical,
  ...enrollmentCategoryOptionsDental,
  ...enrollmentCategoryOptionVision,
]

const EnrollmentCategoryFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredMedicalOptions = enrollmentCategoryOptionsMedical?.filter(
    filterByLabelAndValueCallback(query)
  )
  const filteredDentalOptions = enrollmentCategoryOptionsDental?.filter(
    filterByLabelAndValueCallback(query)
  )
  const filteredVisionOptions = enrollmentCategoryOptionVision?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          { groupLabel: 'Medical', options: filteredMedicalOptions || [] },
          { groupLabel: 'Dental', options: filteredDentalOptions || [] },
          { groupLabel: 'Vision', options: filteredVisionOptions || [] },
        ]}
        placeholder='Search categories to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={enrollmentCategoryOptions || []}
          noSelectionText='Enrollment Category'
          pluralIdentifier='enrollment categories'
        >
          <Boxes size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default EnrollmentCategoryFilter
